import React from "react";
import { useNavigate } from "react-router-dom";
import "./QuizeResult.css";

function ResultPage({ score, total }) {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate("/dashboard");
    };

    return (
        <div className="result-container">
            <div className="result-card">
                <h2>✅ Quiz Complete</h2>
                <p className="score-text">
                    You scored <strong>{score}</strong> out of <strong>{total}</strong>
                </p>
                <button className="back-btn" onClick={handleBack}>
                    🔁 Retake Quiz
                </button>
            </div>
        </div>
    );
}

export default ResultPage;
